import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const get = async (path, params = {}) => {
  const { data } = await axios.get(`${API}${path}`, { params });
  return data;
};

export const adminStats        = ()      => get("/admin/stats");
export const adminUsers        = (q)     => get("/admin/users", q ? { q } : {});
export const adminUserSessions = (id)    => get(`/admin/users/${id}/sessions`);
export const adminSessions     = ()      => get("/admin/sessions");
export const adminPredictions  = ()      => get("/admin/predictions");
export const adminTransactions = ()      => get("/admin/transactions");
export const adminAffiliates   = ()      => get("/admin/affiliates");
export const adminSystem       = ()      => get("/admin/system");
export const adminLotteries    = ()      => get("/lotteries");
export const adminResults      = ()      => get("/results/today");
export const myAffiliates      = ()      => get("/auth/my-affiliates");
